import { PrizeWallWinner } from './prizeWallWinners.types';

export const groupWinnersByRewardId = (winners?: PrizeWallWinner[]) =>
  winners?.reduce<Record<string, PrizeWallWinner[]>>((accumulator, winner) => {
    if (accumulator[winner.rewardId] === undefined) {
      accumulator[winner.rewardId] = [];
    }

    accumulator[winner.rewardId].push(winner);

    return accumulator;
  }, {});
